<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>page.declarations.synthese.changementProduit</h4>
  </div>

  <div class="modal-body" >
    <form [formGroup]="frmChangementDenomination" #form="ngForm" (ngSubmit)="submit()">
      <div class="cols">
        <div class="col">
          <div class="mb-3">
            <label class="form-label" for="origine" translate>page.declarations.synthese.modal.changementDenomination.origine</label>
            <ng-select bindLabel="libelle" formControlName="origine" [items]="produitsOrigine" [multiple]="false" [closeOnSelect]="true"  [searchable]="true" [ngClass]="{'is-invalid': form.submitted && devient.invalid}">
            </ng-select>
          </div>

          <div class="mb-3">
            <label class="form-label" for="devient" translate>page.declarations.synthese.modal.changementDenomination.devient</label>
            <select [formControl]="devient" id="devient" name="devient" class="form-control" [ngClass]="{'is-invalid': form.submitted && devient.invalid, 'select-placeholder' : (devient.value === null && !devient.dirty)}">
              <option [ngValue]="null" hidden selected>{{ 'page.declarations.synthese.modal.changementDenomination.trProduits' | translate }}</option>
              <option *ngFor="let produitDestination of produits" [ngValue]="produitDestination">{{ produitDestination?.produit?.libelle }} ({{ produitDestination?.typeChangement }})</option>
            </select>
          </div>

           <div class="mb-3" *ngIf="typeCahier === 'IGP' && origineHorsBacchus === false ">
              <label class="form-label" for="revendicationliee" translate>
                page.declarations.synthese.modal.changementDenomination.revendication-liee
              </label>
             <button type="button" class="form-control"

                      (click)="openModal()">
                {{
                  mouvementLie?.value
                    ? ('Logement : ' + mouvementLie.value.logement +
                      ' - Numéro de lot : ' + mouvementLie.value.numeroLot +
                      ' - Volume : ' + mouvementLie.value.volume + ' Hl' +
                      ' - Date : ' + (mouvementLie.value.date | date:'dd/MM/yyyy'))
                    : ('page.declarations.synthese.modal.changementDenomination.tr-revendication-liee' | translate)
                }}
              </button>
            </div>

          <div class="mb-3" *ngIf="typeCahier === 'IGP'">
            <label class="form-label" for="select-cepages" translate>page.declarations.synthese.modal.changementDenomination.cepages</label>
            <app-multiselect id="select-cepages" maxWidth="initial" bindLabel="libelle" controlName="cepages" [items]="listeCepage" [ngClass]="{'is-invalid': form.submitted && cepages.invalid}"></app-multiselect>
          </div>

          <div class="mb-3">
            <label class="form-label" for="volume" translate>page.declarations.synthese.modal.changementDenomination.volume</label>
            <input type="text" [formControl]="volume" id="volume" name="volume" class="form-control" [ngClass]="{'is-invalid': form.submitted && volume.invalid, 'select-placeholder' : (volume.value === null && !volume.dirty)}" />
          </div>

          <div class="mb-3">
            <label class="form-label" for="logement" translate>page.declarations.synthese.modal.changementDenomination.logement</label>
            <input type="text" [formControl]="logement" id="logement" name="logement" class="form-control" [ngClass]="{'is-invalid': form.submitted && logement.invalid, 'select-placeholder' : (logement.value === null && !logement.dirty)}" />
          </div>
        </div>

        <div class="col">
          <div class="mb-3">
            <p><label class="form-label" for="typeDeLot" translate>page.declarations.synthese.modal.changementDenomination.typeDeLot</label></p>
            <input type="radio" [formControl]="typeDeLot" id="vrac" name="typeDeLot" value="VRAC" checked /> Vrac
            <input type="radio" [formControl]="typeDeLot" id="conditionne" name="typeDeLot" value="CONDITIONNE" /> Conditionné
          </div>

          <div class="mb-3">
            <label class="form-label" for="numeroLot" translate>page.declarations.synthese.modal.changementDenomination.numeroLot</label>
            <input type="text" [formControl]="numeroLot" id="numeroLot" name="numeroLot" class="form-control" [ngClass]="{'is-invalid': form.submitted && numeroLot.invalid, 'select-placeholder' : (numeroLot.value === null && !numeroLot.dirty)}" />
          </div>

          <div class="mb-3">
            <label class="form-label" for="entreposage" for="entreposage" translate>page.declarations.synthese.modal.changementDenomination.entreposage</label>
            <select [formControl]="entreposage" id="entreposage" name="entreprosage" class="form-control" [ngClass]="{'is-invalid': form.submitted && entreposage.invalid, 'select-placeholder' : (entreposage.value === null && !entreposage.dirty)}">
              <option [ngValue]="null" hidden selected>{{ 'page.declarations.synthese.modal.changementDenomination.listeSites' | translate }}</option>
              <option *ngFor="let siteOperateur of sitesOperateur" [ngValue]="siteOperateur">{{ siteOperateur?.adresse }}</option>
            </select>
          </div>

          <div class="mb-3" *ngIf="typeCahier === 'IGP'">
            <label class="form-label" for="observation" translate>page.declarations.synthese.modal.changementDenomination.observation</label>
            <textarea formControlName="observation" class="form-control" [ngClass]="{'is-invalid': form.submitted && observation.invalid}"></textarea>
          </div>
        </div>
      </div>

      <div class="actions-bar">
        <button type="button" (click)="close()" class="btn btn-light" translate>label.annuler</button>
        <button type="submit" class="btn btn-primary" translate>label.valider</button>
      </div>
    </form>
  </div>
</div>

<!-- MODAL -->
<div class="modal fade" tabindex="-1" role="dialog" [ngClass]="{'show d-block': showModal}" *ngIf="showModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" translate>page.declarations.synthese.modal.changementDenomination.revendication-liee</h5>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <table class="table table-hover" aria-label="Liste des mouvements liés">
          <thead>
            <tr>
              <th>Logement</th>
              <th>Numéro de Lot</th>
              <th>Volume</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let mouvementlie of mouvements"
                (click)="selectMouvement(mouvementlie)"
                [class.table-active]="mouvementLie.value === mouvementlie"
                style="cursor: pointer;">
              <td>{{ mouvementlie.logement }}</td>
              <td>{{ mouvementlie.numeroLot }}</td>
              <td>{{ mouvementlie.volume }}</td>
              <td>{{ mouvementlie.date | date:'dd/MM/yyyy' }}</td>
            </tr>

          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Fermer</button>
      </div>
    </div>
  </div>
</div>


